import React from "react";
import classes from './Symbol.module.css';

const CrossSvg = () => {
    return (
        <>
            <svg className={classes["symbol"]} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#e65439">
                <path d="M19.706 4.293a1 1 0 00-1.414 0L12 10.586 5.707 4.293a1 1 0 10-1.414 1.414L10.586 12 4.293 18.293a1 1 0 001.414 1.414L12 13.414l6.293 6.293a1 1 0 001.414-1.414L13.414 12l6.293-6.293a1 1 0 000-1.414z" />
            </svg>
        </>
    )
};

export default CrossSvg;